/**
 * AUTO-GENERATED by scripts/seo-engine. DO NOT EDIT BY HAND.
 * Regenerate with: cd scripts/seo-engine && node bin/run.js publish
 * 0 article(s).
 */
export const GENERATED_POSTS = [];
